module.exports = __webpack_public_path__ + "img/4.91755d0d.jpg";